import {LEISTUNGSART_VALUES, LEISTUNGSART_KEYMAP} from "@/components/kundenverwaltung/valueLists";

export function formatLeistungsart(value) {
  let keyValue = keyMapLeistungsart(value);
  let ret = LEISTUNGSART_VALUES.find(item => item.value && keyValue && item.value === keyValue.toLowerCase());
  if (ret && ret.text) {
    return ret.text;
  } else {
    return ' ';
  }
}
export function keyMapLeistungsart(value) {
  let oKeyMap = LEISTUNGSART_KEYMAP;
  return oKeyMap.from.includes(value) ? oKeyMap.to : value;
}